const isPresentInAnyOf = (value: string, containers: string [], respectCase?: boolean) =>
  Boolean(containers.find(container => {
    if (respectCase) {
      return container.includes(value)
    }

    return container.toLowerCase().includes(value.toLowerCase())
  }))

export default isPresentInAnyOf



// WEBPACK FOOTER //
// ./src/utils/is-present-in-any-of.ts